module.exports = __webpack_public_path__ + "img/seedlingseedling_green.278f16e0.svg";